<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	export let x = 0;
	export let y = 0;
	export let visible = false;

	const dispatch = createEventDispatcher<{
		edit: void;
		copy: void;
		cut: void;
		findUsages: void;
		replaceDevice: void;
		extractSubflow: void;
		delete: void;
		cancel: void;
	}>();

	function close() {
		dispatch('cancel');
		visible = false;
	}
</script>

{#if visible}
	<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
	<div class="fn-backdrop" on:click={close} role="presentation" />
	<div class="fn-menu" style="left:{x}px; top:{y}px;" role="menu" aria-label="Node actions">
		<button
			type="button"
			class="fn-item"
			role="menuitem"
			on:click={() => {
				dispatch('edit');
				visible = false;
			}}
		>
			<i class="fa fa-sliders-h" />
			<span>Edit</span>
		</button>
		<button
			type="button"
			class="fn-item"
			role="menuitem"
			on:click={() => {
				dispatch('copy');
				visible = false;
			}}
		>
			<i class="fa fa-copy" />
			<span>Copy</span>
		</button>
		<button
			type="button"
			class="fn-item"
			role="menuitem"
			on:click={() => {
				dispatch('cut');
				visible = false;
			}}
		>
			<i class="fa fa-cut" />
			<span>Cut</span>
		</button>
		<button
			type="button"
			class="fn-item"
			role="menuitem"
			on:click={() => {
				dispatch('findUsages');
				visible = false;
			}}><i class="fa fa-link" /><span>Find usages</span></button
		>
		<button
			type="button"
			class="fn-item"
			role="menuitem"
			on:click={() => {
				dispatch('replaceDevice');
				visible = false;
			}}><i class="fa fa-repeat" /><span>Replace device</span></button
		>
		<button
			type="button"
			class="fn-item"
			role="menuitem"
			on:click={() => {
				dispatch('extractSubflow');
				visible = false;
			}}><i class="fa fa-puzzle-piece" /><span>Extract reusable subflow</span></button
		>
		<div class="fn-sep" />
		<button
			type="button"
			class="fn-item danger"
			role="menuitem"
			on:click={() => {
				dispatch('delete');
				visible = false;
			}}
		>
			<i class="fa fa-trash" />
			<span>Delete</span>
		</button>
	</div>
{/if}

<style>
	.fn-backdrop {
		position: fixed;
		inset: 0;
		z-index: 12002;
		background: transparent;
	}

	.fn-menu {
		position: fixed;
		z-index: 12003;
		background: #2a2a2a;
		border: 1px solid #3a3a3a;
		border-radius: 8px;
		min-width: 160px;
		overflow: hidden;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
		padding: 4px 0;
	}

	.fn-item {
		display: flex;
		align-items: center;
		gap: 0.6rem;
		width: 100%;
		padding: 0.5rem 0.85rem;
		background: transparent;
		border: none;
		color: #e5e5e5;
		font-size: 0.85rem;
		cursor: pointer;
		text-align: left;
	}

	.fn-item:hover {
		background: #3a3a3a;
	}

	.fn-item.danger:hover {
		background: #450a0a;
		color: #fecaca;
	}

	.fn-item i {
		width: 18px;
		text-align: center;
		font-size: 0.85rem;
		color: #9ca3af;
	}

	.fn-item.danger i {
		color: #f87171;
	}

	.fn-sep {
		height: 1px;
		background: #3a3a3a;
		margin: 4px 0;
	}
</style>
